<template>
  <el-card v-loading="isLoading">
    <header slot="header">
      <el-page-header @back="$router.back()" content="Create Role" />
    </header>

    <section>
      <h4>Role</h4>

      <el-row>
        <el-col :span="24">
          <label>Name</label>
          <el-input 
            v-model="role.display_name" 
            :disabled="isSaving"
            placeholder="Foo Bar"
            maxlength="30"
            show-word-limit>
            <template slot="append">{{ role.name || 'foo-bar' }}</template>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <label>Description</label>
          <el-input 
            v-model="role.description" 
            :disabled="isSaving"
            type="textarea" 
            placeholder="Foo Bar lets users.."
            maxlength="191">
            Description
          </el-input>
        </el-col>
      </el-row>
    </section>
    
    <section>
      <h4>Permissions</h4>
      <el-row>
        <el-col :span="24">
          <el-transfer
            v-model="role.permissions"
            :data="allPermissions"
            :titles="['Available', 'Owned']">
          </el-transfer>
        </el-col>
      </el-row>

      <el-divider />

      <el-row>
        <el-col :span="24">
          <el-button 
            type="primary" 
            @click="create"
            :loading="isSaving">
            Create
          </el-button>
        </el-col>
      </el-row>
    </section>
  </el-card>
</template>

<script>
  import axios from '../../repositories/Repository';
  import { notify } from '../../utils';
  import { RepositoryError } from '../../repositories/errors';

  export default {
    name: 'CreateRole',
    data() {
      return {
        role: {
          name: '',
          display_name: '',
          description: '',
          permissions: [],
        },
        permissions: [],
        state: '',
      };
    },
    computed: {
      allPermissions() {
        return this.permissions.map(
          permission => ({
            key: permission.name,
            label: permission.display_name || permission.name,
            disabled: this.isSaving,
          })
        );
      },
      isLoading() {
        return this.state === 'loading';
      },
      isSaving() {
        return this.state === 'saving';
      },
    },
    async mounted() {
      this.state = 'loading';
      await this.fetchPermissions(),
      this.state = '';
    },
    methods: {
      async create() {
        this.state = 'saving';

        // Must be synchronous API calls
        try {
          const response = await axios.post('/auth/roles', {
            name: this.role.name,
            display_name: this.role.display_name,
            description: this.role.description,
          });

          const role_id = response.data.id;
          if (this.role.permissions.length > 0) {
            await axios.put(`/auth/role-permissions/${role_id}`, {
              permissions: this.role.permissions,
            });
          }

          notify(`Successfully created new role ${this.role.display_name}`, 'success');
          this.$router.push({ name: 'roles' });
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }
          
          throw err;
        } finally {
          this.state = '';
        }
      },
      async fetchPermissions() {
        try {
          const response = await axios.get('/auth/permissions');
          
          this.permissions = response.data;
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        }
      },
    },
    watch: {
      'role.display_name': function(display_name) {
        this.role.name = display_name.replace(' ', '-').toLowerCase();
      },
    },
  };
</script>
